import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';
import rtl from 'styled-components-rtl';
import { constants } from '../../modules/utils/constants/constants';

export const StyledPropertyDetails = styled.div<{ isCardVertical: boolean }>`
  box-shadow: rgba(0, 0, 0, 0.07) 0 ${toRem(4)} ${toRem(20)} 0;
  border-radius: ${toRem(14)};
  overflow: hidden;
  height: ${props => (props?.isCardVertical ? `inherit` : `${toRem(559)}`)};

  .property-details__details-container {
    width: 100%;
    word-break: break-word;
    white-space: normal;
    height: ${props => (props?.isCardVertical ? `${toRem(289)}` : `${toRem(332)}`)};

    @media ${baseVariables.mediaQuery.md},
      @media ${baseVariables.mediaQuery.lg},
      @media ${baseVariables.mediaQuery.xl} {
      height: ${props => (props?.isCardVertical ? `${toRem(289)}` : 'unset')};
    }

    &_footer_link {
      min-width: ${toRem(128)};
    }
  }

  .icon-decorative {
    &::before {
      font-size: ${toRem(24)};
      line-height: ${toRem(24)};
    }
  }

  .property-details__img-container {
    width: 100%;
    height: ${props => (props?.isCardVertical ? `${toRem(228)}` : ` ${toRem(228)}`)};
    position: relative;

    &--img {
      height: ${props => (props?.isCardVertical ? `${toRem(228)}` : ` ${toRem(228)}`)};
      width: 100%;
    }
  }

  .property-details__img-container--logo {
    position: absolute;
    z-index: 2;
    bottom: ${toRem(16)};
    left: ${toRem(16)};
    width: ${toRem(124)};
    min-height: ${toRem(60)};
    background-color: transparent;
    border-radius: ${toRem(4)};

    /* ${rtl`
      // &:is(${constants.RTL_LANG_LIST}) {
        // right: ${toRem(16)};
      // }
    `} */

    .brand-logo-container {
      background: transparent;
    }
    .brand-logo-SH::before {
      font-size: ${toRem(35)};
    }
    .brand-logo-GE::before {
      font-size: ${toRem(39)};
    }
    .brand-logo-AR::before {
      font-size: ${toRem(45)};
    }
    .brand-logo-AL::before {
      font-size: ${toRem(39)};
    }
    .brand-logo-AK::before {
      font-size: ${toRem(35)};
    }
    .brand-logo-CY::before {
      font-size: ${toRem(15)};
    }
    .brand-logo-DE::before {
      font-size: ${toRem(46)};
    }
    .brand-logo-DS::before {
      font-size: ${toRem(11)};
    }
    .brand-logo-BG::before {
      font-size: ${toRem(24)};
    }
    .brand-logo-EB::before {
      font-size: ${toRem(16)};
    }
    .brand-logo-EL::before {
      font-size: ${toRem(40)};
    }
    .brand-logo-FI::before {
      font-size: ${toRem(19)};
    }
    .brand-logo-FP::before {
      font-size: ${toRem(33)};
    }
    .brand-logo-JW::before {
      font-size: ${toRem(37)};
    }
    .brand-logo-MD::before {
      font-size: ${toRem(16)};
    }
    .brand-logo-ER::before {
      font-size: ${toRem(40)};
    }
    .brand-logo-MI::before {
      font-size: ${toRem(33)};
    }
    .brand-logo-MV::before {
      font-size: ${toRem(39)};
    }
    .brand-logo-MC::before {
      font-size: ${toRem(33)};
    }
    .brand-logo-OX::before {
      font-size: ${toRem(27)};
    }
    .brand-logo-PR::before {
      font-size: ${toRem(40)};
    }
    .brand-logo-BR::before {
      font-size: ${toRem(42)};
    }
    .brand-logo-RI::before {
      font-size: ${toRem(20)};
    }
    .brand-logo-SI::before {
      font-size: ${toRem(40)};
    }
    .brand-logo-XR::before {
      font-size: ${toRem(38)};
    }
    .brand-logo-LC::before {
      font-size: ${toRem(43)};
    }
    .brand-logo-RZ::before {
      font-size: ${toRem(40)};
    }
    .brand-logo-TS::before {
      font-size: ${toRem(32)};
    }
    .brand-logo-TX::before {
      font-size: ${toRem(20)};
    }
    .brand-logo-WH::before {
      font-size: ${toRem(18)};
    }
    .brand-logo-WI::before {
      font-size: ${toRem(20)};
    }
    .brand-logo-XE::before {
      font-size: ${toRem(29)};
    }
    .brand-logo-XF::before {
      font-size: ${toRem(32)};
    }
    .brand-logo-SN::before {
      font-size: ${toRem(50)};
    }
    .brand-logo-RS::before {
      font-size: ${toRem(20)};
    }
  }

  @media ${baseVariables.mediaQuery.md} {
    height: ${props => (props?.isCardVertical ? 'inherit' : `${toRem(371)}`)};

    .property-details__img-container,
    .property-details__img-container--img {
      width: ${props => (props?.isCardVertical ? '100%' : `${toRem(360)}`)};
      height: ${props => (props?.isCardVertical ? `${toRem(228)}` : `${toRem(371)}`)};
    }
  }

  @media ${baseVariables.mediaQuery.lg} {
    height: ${props => (props?.isCardVertical ? `inherit` : `${toRem(403)}`)};

    .property-details__img-container,
    .property-details__img-container--img {
      width: ${props => (props?.isCardVertical ? '100%' : `${toRem(571)}`)};
      height: ${props => (props?.isCardVertical ? `${toRem(228)} !important` : `${toRem(403)}`)};
    }
  }

  @media ${baseVariables.mediaQuery.xl} {
    height: ${props => (props?.isCardVertical ? 'inherit' : ` ${toRem(403)}`)};

    .property-details__img-container,
    .property-details__img-container--img {
      width: ${props => (props?.isCardVertical ? '100%' : `${toRem(658)}`)};
      height: ${props => (props?.isCardVertical ? `${toRem(298)}` : ` ${toRem(403)}`)};
    }
  }

  .property-details__details-container_top {
    padding: ${props => (props?.isCardVertical ? `${toRem(16)} ${toRem(16)} 0` : `${toRem(16)} ${toRem(16)} 0`)};

    @media ${baseVariables.mediaQuery.md} {
      padding: ${props => (props?.isCardVertical ? `${toRem(16)} ${toRem(16)} 0` : `${toRem(32)} ${toRem(32)} 0`)};
    }

    @media ${baseVariables.mediaQuery.lg}, @media ${baseVariables.mediaQuery.xl} {
      padding: ${props => (props?.isCardVertical ? `${toRem(16)} ${toRem(16)} 0` : `${toRem(48)} ${toRem(48)} 0`)};
    }
  }

  .property-details__details-container_top,
  .property-details__details-container_bottom {
    width: 100%;
  }

  .separator {
    border-top: ${props =>
      props?.isCardVertical
        ? `${toRem(1)} solid ${baseVariables.color['neutral20']}`
        : `${toRem(1)} solid ${baseVariables.color['neutral40']}`};
  }

  .property-details__details-container_desc,
  .property-details__details-container_desc > div,
  .property-details__title,
  .property-details__subTitle,
  .property-details__address {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .property-details__details-container_desc,
  .property-details__details-container_desc > div {
    -webkit-line-clamp: 3;
  }

  .property-details__title {
    -webkit-line-clamp: 2;
  }

  .property-details__subTitle,
  .property-details__address {
    -webkit-line-clamp: 1;
  }

  .property-details__title,
  .property-details__subTitle,
  .property-details__details-container_desc {
    p {
      margin-bottom: 0;
    }
  }
`;

/* ${rtl`
    // &:is(${constants.RTL_LANG_LIST}) {
      // .m-link-tertiary-button, .m-link-tertiary-button-external {
        // &::after {
          // content: ${(props: { isCardVertical: boolean }) =>
            //props?.isCardVertical ? `${`'\\e927'`}` : `${`'\\e966'`}`};
          // padding-right: ${(props: { isCardVertical: boolean }) => (props?.isCardVertical ? `${toRem(8)}` : 0)};
        // }
      // }
    // }
  `} */
